import styled from '@emotion/styled'
import { gsColors } from '../../../styles/Variables'
import { mq } from '../../../helpers'

export const GroupSelectionWrapper = styled.ul`
  ul {
    width: 100%;
    display: flex;
    justify-content: center;
    column-gap: 20px;

    // ${mq('max', '600px')} {
    //   display: none;
    // }

    li {

      button {
        box-sizing: border-box;
        background-color: transparent;
        border: 1px solid ${gsColors.lightTangerine};
        border-radius: 500px;
        padding: 8px 13px;
        color: ${gsColors.meredithGrey};
        text-align: center;
        font-family: Euclid;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
        cursor: pointer;

        &:hover, &.selected-group {
          background-color: ${gsColors.sunsetOrange};
          color: #FFF;
          border: 1px solid ${gsColors.sunsetOrange};
        }
      }
    }
  }

  // .selected-group {
  //   // border-bottom: 1px solid ${gsColors.sunsetOrange};
  // }

  // li:hover {
  //   // border-bottom: 1px solid ${gsColors.sunsetOrange};
  // }

  // button {
  //   min-width: 0;
  //   padding: 20px 0;
  // }

  // .mobile-group-selector {
  //   display: none;

  //   ${mq('max', '600px')} {
  //     display: block;
  //   }
  // }
`

export const MobileSelectWrapper = styled.div`
  position: relative;

  .group-selector-container {
    background-color: transparent;
    border: none;
    width: max-content;
    padding: 0 1rem;
    border-bottom: 1px solid black;
    display: flex;
    align-items: center;
    &:hover {
      cursor: pointer;
      color: ${gsColors.sunsetOrange};
    }
  }

  .group-select-arrow {
    font-size: 2rem;
    margin: 0 1rem;
    transition: all 0.2s ease;
    color: ${gsColors.black};
  }

  .arrow-open {
    transform: rotate(0.5turn);
    color: ${gsColors.saltBox};
  }

  .group-list-container {
    background-color: ${gsColors.white};
    height: auto;
    max-height: 0px;
    transition: all 0.5s ease-in-out;
    position: absolute;
    overflow: hidden;
    opacity: 0;
    // transform: translate(1rem, 0);
    display: flex;
    flex-direction: column;
    z-index: 100;
  }

  .list-open {
    max-height: 1000px;
    opacity: 1;
    transition: all 0.2s ease-in-out;
  }

  .group-list-item {
    background-color: transparent;
    border: none;
    font-size: 16px;
    font-family: brown;
    text-align: left;
    // margin: 1rem;
    margin: 1rem 0;
    padding: 0 1rem;
    font-weight: 300;
    color: ${gsColors.black};
    &:hover {
      cursor: pointer;
      color: ${gsColors.sunsetOrange};
    }
  }
  .group-selected {
    color: ${gsColors.sunsetOrange};
  }
`
